import { useState } from 'react';

import { DesktopNavigationItem, MobileNavigationItem } from './NavigationItem';

import type React from 'react';
import type { NavItem } from '@widget/api/types';

type NavigationProps = {
  navItems: NavItem[];
  isMobileNavigation: boolean;
};

export const Navigation: React.FC<NavigationProps> = ({ navItems, isMobileNavigation = false }) => {
  const [current, setCurrent] = useState('');

  const updateCurrent = (name: string): void => {
    if (current === name) return setCurrent('');
    setCurrent(name);
  };

  const NavigationItem = isMobileNavigation ? MobileNavigationItem : DesktopNavigationItem;

  return (
    <>
      {navItems.map((navItem, index) => (
        <NavigationItem
          navItem={navItem}
          current={current}
          setCurrent={updateCurrent}
          key={index}
        />
      ))}
    </>
  );
};
